import { render, staticRenderFns } from "./CopFreightSearchView.vue?vue&type=template&id=1c58b33a"
import script from "./CopFreightSearchView.vue?vue&type=script&lang=js"
export * from "./CopFreightSearchView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports